module.exports = __webpack_public_path__ + "static/media/In the Rain.1d0d7131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/In the Rain.jpg
// module id = 293
// module chunks = 0